export var btnHeight = '36px';
export var inputHeight = btnHeight;
export var inputTextWidth = '300px';
export var tabActiveIndicatorHeight = '2px';
export var tinySpace = '4px';
export var smallSpace = '8px';
export var mediumSpace = '16px';
export var mediumLargeSpace = '24px';
export var largeSpace = '32px';